export const appointmentTypeColumns = [
  {
    title: 'Client-info Therapy Title',
    key: 'title',
    dataIndex: 'title'
  }
];
